exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody[data-v-eb12cfde]{display:block;height:400px;overflow:auto}tbody tr[data-v-eb12cfde],thead[data-v-eb12cfde]{display:table;width:100%;table-layout:fixed}thead[data-v-eb12cfde]{width:100%}", ""]);

// exports
